import { defineComponent as _defineComponent } from 'vue'
import { BillingInfo } from '@/models/billingInfo';
import { customersService } from '@/services/tenants.service';
import { isEmpty, isNil } from '@/utils/misc';
import {
  generateLocalizedCustomSearch,
  matchIgnoringCase,
  searchByDateField,
} from '@/utils/table';
import moment from 'moment';
import TableWithActions from '@/components/tableWithActions/TableWithActions.vue';
import { computed, onBeforeMount, ref } from 'vue';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ControlList',
  setup(__props) {

const viewOnDate = ref(new Date());
const billingInfo = ref<BillingInfo[]>([]);
const isLoading = ref(false);
const isPreparingDownload = ref(false);

const datepickerRef = ref<any>(null);

const { t } = useI18n();

onBeforeMount(async () => {
  await getBillingInfo();
});

async function confirmDownload() {
  isPreparingDownload.value = true;
  await customersService
    .getBillingInfo(true, dateString.value)
    .finally(() => (isPreparingDownload.value = false));
}

function formatDate(date: Date | null) {
  if (date instanceof Date) {
    return moment(date).format('YYYY-MM-DD');
  }
  return '';
}

async function getBillingInfo() {
  isLoading.value = true;
  try {
    billingInfo.value = await customersService.getBillingInfo(
      false,
      dateString.value,
    );
  } finally {
    isLoading.value = false;
  }
}

function toggleDatepicker() {
  datepickerRef.value?.toggle();
}

function searchByField(
  key: string,
): (item: any, searchTerm: string) => boolean {
  return (item, searchTerm) => {
    if (isEmpty(item[key])) {
      return false;
    }
    return matchIgnoringCase(String(item[key]), searchTerm);
  };
}

const dateString = computed((): string => {
  return moment(viewOnDate.value)
    .subtract(viewOnDate.value.getTimezoneOffset(), 'minutes')
    .format('YYYY-MM-DD');
});

return { __sfc: true,viewOnDate, billingInfo, isLoading, isPreparingDownload, datepickerRef, t, confirmDownload, formatDate, getBillingInfo, toggleDatepicker, searchByField, dateString, isNil, generateLocalizedCustomSearch, searchByDateField, TableWithActions }
}

})